import { useCallback } from 'react';
import { useMarkReportHistoryEntryAsReviewed as useMarkReportHistoryEntryAsReviewedApi } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';

const TRANS_KEY_NOTIFICATION = 'NOTIFICATIONS.MARK_REPORT_REVIEWED';

type UseMarkReportHistoryEntryAsReviewedReturnType = {
  markAsReviewed: (entryId: string) => void;
  pendingEntryId: string | undefined;
};

// The report history refetch is triggered by the generated mutation (see orval.config.ts).
export const useMarkReportHistoryEntryAsReviewed =
  (): UseMarkReportHistoryEntryAsReviewedReturnType => {
    const { showError } = useNotification();

    const { mutate, isPending, variables } =
      useMarkReportHistoryEntryAsReviewedApi<AxiosError>({
        mutation: {
          onError: (error) => {
            showError({
              title: `${TRANS_KEY_NOTIFICATION}.ERROR.TITLE`,
              message: `${TRANS_KEY_NOTIFICATION}.ERROR.MESSAGE`,
              error,
            });
          },
        },
      });

    const markAsReviewed = useCallback(
      (entryId: string) => {
        mutate({ entryId });
      },
      [mutate]
    );

    return {
      markAsReviewed,
      pendingEntryId: isPending ? variables?.entryId : undefined,
    };
  };
